import { KodanshaWheel } from '../KodanshaWheel/KodanshaWheel';
import React, { useEffect, useState } from 'react';
import { FetchBrowseAtom, LatestAndGreatestWheelAtom, UpcomingReleasesAtom } from '../../store/DiscoverStore';
import { useAtom } from 'jotai';

export function KodanshaCustomWheelSection(): JSX.Element {
    const [latestAndGreatest] = useAtom(LatestAndGreatestWheelAtom);
    const [upcoming] = useAtom(UpcomingReleasesAtom);

    useEffect(() => {

           console.log("Get Latest and Greatest");

    }, []);

    return(
        <div>
            {/*{latestAndGreatest.length > 0 &&*/}
            {/*    <KodanshaWheel key={"custom-1"} discoverId={null}*/}
            {/*                   title={"Check out our latest and greatest"}*/}
            {/*                   secondTitle={"THIS WEEK'S NEW MANGA RELEASES"}*/}
            {/*                   preFetchedItems={latestAndGreatest}*/}
            {/*                   useCTA={true}*/}
            {/*                   buttonUrl={'/browse/new/'}*/}
            {/*                   ctaText={"View More Releases"}/>}*/}
            {upcoming.length > 0 && <KodanshaWheel key={"custom-2"} discoverId={null}
                                       title={"I see more manga in your future..."}
                                       secondTitle={"UPCOMING RELEASES"}
                                       preFetchedItems={upcoming}
                                       useCTA={true}
                                       buttonUrl={'/calendar/'}
                                       ctaText={"View Release Schedule"}/>}
        </div>
    );
}
